import { useMutation, useQueryClient } from '@tanstack/react-query'
import supabase from 'sdk/api';

const addReview = async (
    text: string,
    rank: number,
    product?: string,
    media?: string[],
    name?: string,
    isAnon?: boolean
) => {
    if (!text) {
        throw new Error('Comment should not be empty')
    }
    const { data: userData } = await supabase.auth.getSession()

    const { data: reportData, error } = await supabase
        .from('product_reviews')
        .insert({
            text,
            rank,
            product,
            user: userData?.session?.user?.id,
            media,
            name: isAnon ? "Anonymous" : name
        })
        .select()
        .single();

    if (error) {
        throw new Error(error.message)
    }

    return reportData
}

export default function useAddProductReview(
    text: string,
    rank: number,
    product?: string,
    media?: string[],
    name?: string,
    isAnon?:boolean
) {
    const queryClient = useQueryClient()

    return useMutation(() => addReview(text, rank, product, media, name, isAnon), {
        onSuccess: async (res) => {
            queryClient.invalidateQueries({ queryKey: ['reports'] })
            return res
        },
    })
}
